var _rect, _path, _circle, _circle2, _circle3, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGallery = function SvgGallery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 27 28"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19.059,
    height: 13.5,
    x: 3.529,
    y: 1,
    stroke: "currentColor",
    strokeWidth: 1.3,
    rx: 2.382
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    d: "m3.53 13.64 7.11-7.081 7.977 7.94"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.823,
    cy: 5.765,
    r: 1.732,
    stroke: "currentColor",
    strokeWidth: 1.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.117,
    cy: 19.265,
    r: 1.588,
    stroke: "currentColor",
    strokeWidth: 1.3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 19.265,
    r: 1.588,
    stroke: "currentColor",
    strokeWidth: 1.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.3,
    d: "M5.117 22.441s4.656 1.576 7.858 1.589C16.239 24.042 21 22.44 21 22.44M5.117 20.853V28M21 20.853V28"
  })));
};
export default SvgGallery;